module.exports = __webpack_public_path__ + "static/media/image3.125c5835.jpg";